import { defineMessages } from 'react-intl';
import { insightsPages as InsightsPages } from '../../nav-items';

export const headerMessages = {
  [InsightsPages.overview]: defineMessages({
    headerMessage: {
      defaultMessage: 'Overview',
      id: 'GbTzo4',
      description: 'insights overview page header',
    },
  }),
  [InsightsPages.operations]: defineMessages({
    headerMessage: {
      defaultMessage: 'Operations',
      id: 'lkrf1H',
      description: 'insights page header for ecommerce operations',
    },
  }),
  [InsightsPages.tracking]: defineMessages({
    headerMessage: {
      defaultMessage: 'Customer Engagement',
      id: 'egIhQf',
      description: 'insights customers engagement page header',
    },
  }),
  [InsightsPages.sales]: defineMessages({
    headerMessage: {
      defaultMessage: 'Sales Trends',
      id: 'GCYR0H',
      description: 'insights sales trends page header',
    },
  }),
  [InsightsPages.customers]: defineMessages({
    headerMessage: {
      defaultMessage: 'Customer Overview',
      id: '6YMOsC',
      description: 'insights customers overview page header',
    },
  }),
  [InsightsPages.products]: defineMessages({
    headerMessage: {
      defaultMessage: 'Product Highlights',
      id: 'pOFCOs',
      description: 'insights product highlights page header',
    },
  }),
};

export const analyticsReportTitles = defineMessages({
  [InsightsPages.products]: defineMessages({
    headerMessage: {
      defaultMessage: 'Products',
      id: 'pKD9Fp',
      description: 'Title for the analytics Products report',
    },
  }),
  [InsightsPages.sales]: defineMessages({
    headerMessage: {
      defaultMessage: 'Sales & Customers',
      id: 'i2hLIp',
      description: 'Title for the analytics Sales and Customers report',
    },
  }),
  [InsightsPages.operations]: defineMessages({
    headerMessage: {
      defaultMessage: 'Shipments Overview',
      id: '1umSOI',
      description: 'Title for the new Shipments Overview report',
    },
  }),
  [InsightsPages.overview]: defineMessages({
    headerMessage: {
      defaultMessage: 'Orders Overview',
      id: 'SPcG0U',
      description: 'Title for the new Orders Overview report',
    },
  }),
});

const messages = defineMessages({
  storeDropdownLabel: {
    defaultMessage: 'Store',
    id: 'w8OSRG',
    description: 'Select store dropdown label',
  },
  dateRangeDropdownLabel: {
    defaultMessage: 'Date Range',
    id: 'FZSQtB',
    description: 'date ramge dropdown label',
  },
  allStoresOption: {
    defaultMessage: 'All Stores',
    id: 'oLJ8Ov',
    description: 'store dropdown toggler option',
  },
});

export default messages;
